/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class Report extends React.Component {
  render() {
    return <div className='dms-body'>
      {this.props.children}
    </div>
  }
};
export default Report;


// WEBPACK FOOTER //
// ./src/routes/report/index.js